import {
  h,
} from "vue";
import DialogBody from "~/services/blocked-access-dialog/body.vue";
import DialogFooter from "~/services/blocked-access-dialog/footer.vue";
import {
  useDialogStoreV2,
} from "~/components/abstract-dialog/useDialogStoreV2";
import {
  useSessionStore,
} from "~/stores/session";

export function useBlockedAccessDialog() {
  const dialogStoreV2 = useDialogStoreV2();
  const sessionStore = useSessionStore();

  const handleLogout = () => {
    hideDialog();
    sessionStore.logout();
  };

  const {hideDialog} = dialogStoreV2.showDialog({
    titleComponent: null,
    bodyComponent: () => h(DialogBody),
    footerComponent: () =>
      h(DialogFooter, {
        onLogout: handleLogout,
      }),
    options: {
      dialogClass: "blocked-access-dialog",
      dialogWidth: "min(480px, calc(100vw - 32px))",
      dialogMinWidth: "",
      dialogMinHeight: "",
      showClose: false,
      allowCloseByEscape: false,
    },
  });
}
